//import { sections } from '../constants/sections';
import { CHANGE_SECTION, SET_SECTIONS } from '../constants/action_types';

const initialState = { sections: {}, selected: '' };

export default function (state = initialState, action) {
    switch (action.type) {
        case CHANGE_SECTION:
            return { ...state, selected: Object.keys(state.sections)[action.payload] };
        case SET_SECTIONS:
            return { sections: action.payload, selected: Object.keys(action.payload)[0] };
        default:
            return state;
    }
}